import React from "react";
import { Wizard } from "react-use-wizard";
import AccountDetails from "components/AccountDetails";
import ShippingAddress from "components/ShippingAddress";
import Payment from "components/Payment";
import { GetStep } from "context/CheckoutContext";
import Subscription from "./Subscription";
import ConfirmOrderSuccess from "./ConfirmOrderSuccess";

// Function to check if the cart only contains Annual Ambassador Suite
const shouldSkipSubscription = (cart) => {
  if (!cart.cart.autoOrderItems?.length) return true;

  if (cart.cart.autoOrderItems.length === 1) {
    return cart.cart.autoOrderItems[0].productTitle === "Annual Ambassador Suite";
  }

  return false;
};

const CheckoutWizard = ({ cart }) => (
  <Wizard startIndex={GetStep(cart)}>
    <AccountDetails customer={cart.customer} referral={cart.cart.referral} />
    {cart.shopifyCustomer.mainAddress !== undefined ? (
      <ShippingAddress
        addresses={[
          cart.shopifyCustomer.mainAddress,
          cart.shopifyCustomer.mailingShippingAddress,
          cart.shopifyCustomer.otherShippingAddress,
        ]}
        contact={cart.customer.email}
        referral={cart.cart.referral}
      />
    ) : (
      <ShippingAddress
        contact={cart.customer.email}
        referral={cart.cart.referral}
      />
    )}
    {cart.cart.autoOrderItems &&
      cart.cart.autoOrderItems.length > 0 &&
      !shouldSkipSubscription(cart) && <Subscription cart={cart} />}
    <Payment
      cart={cart}
      shouldSkipSubscription={() => shouldSkipSubscription(cart)}
    />
    <ConfirmOrderSuccess cart={cart} />
  </Wizard>
);

export default CheckoutWizard;
